<template>
  <div class="mx-auto my-2">
    <v-card class="basil">
      <v-card-title class="text-left justify-left py-6">
        <div class="pre-service-header">
          <div class="pre-service-header__title">Pre-service</div>
          <div class="pre-service-header__subtitle">{{ selectedProgram.label }}</div>
        </div>
      </v-card-title>

      <div class="pre-service-content">
        <component
            :is="selectedProgram.component"
            :key="selectedProgram.key"
            v-bind="selectedProgram.props"
        ></component>
      </div>
    </v-card>
  </div>
</template>

<script>
import GenericEntries from "./GenericEntry/generic-entries";
import PostBasic from "./PostBasic/post-basics.vue";
import PostGraduate from "./PostGraduate/post-gaduate.vue";
import NimeiProgram from "@/components/Graduates/NimeiProgram/nimei-program.vue";

const PROGRAM_ITEMS = [
  {
    key: "tvet-program",
    label: "TVET Program",
    component: "NimeiProgram",
    props: {
      categoryLabel: "TVET Program",
      levelType: "TVET Program",
      preServiceLevel: "TVETProgram",
    },
  },
  {
    key: "generic-entry",
    label: "Generic Entry",
    component: "GenericEntries",
    props: {},
  },
  {
    key: "post-basic",
    label: "Post Basic",
    component: "PostBasic",
    props: {},
  },
  {
    key: "post-graduate",
    label: "Post Graduate",
    component: "PostGraduate",
    props: {},
  },
  {
    key: "graduate-entry",
    label: "Graduate Entry",
    component: "NimeiProgram",
    props: {},
  },
];

export default {
  props: {
    programKey: {
      type: String,
      default: "tvet-program",
    },
  },
  components: {
    NimeiProgram,
    GenericEntries,
    PostBasic,
    PostGraduate,
  },
  data() {
    return {
      programItems: PROGRAM_ITEMS,
    };
  },
  computed: {
    selectedProgram() {
      return this.getProgramByKey(this.programKey) || this.programItems[0];
    },
  },
  methods: {
    normalizeTabKey(value) {
      return (value || "")
        .toString()
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-");
    },
    getProgramByKey(key) {
      return this.programItems.find((item) => {
        return this.normalizeTabKey(item.key) === this.normalizeTabKey(key);
      });
    },
  },
};
</script>

<style scoped>
.basil {
  background-color: #eff6ff !important;
}

.basil--text {
  color: #356859 !important;
}

.basil {
  background-color: #eff6ff !important;
}

.basil--text {
  color: #356859 !important;
}

.pre-service-header__title {
  font-size: 1.125rem;
  font-weight: 600;
}

.pre-service-header__subtitle {
  margin-top: 4px;
  font-size: 0.9rem;
  color: #475569;
}

.pre-service-content {
  min-height: 100vh;
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
> .v-input__control
> .v-input__slot {
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px 0 rgb(0 0 0 / 6%) !important;
}
</style>
